import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SubmitButton } from '@components';
import type { INotification } from '@features';

import {
  StyledNotificationContainer,
  StyledNotificationButtonContainer,
  StyledNotificationContentContainer,
  StyledNotificationTitleContainer
} from './NotificationContent.styled';

export interface IChallengeNotificationContent {
  notification: INotification
  deleteNotification: () => void;
}

const ChallengeNotificationContent = ({
  notification,
  deleteNotification
}: IChallengeNotificationContent) => {
  const navigate = useNavigate();

  return (
    <StyledNotificationContainer >
      <StyledNotificationTitleContainer>
        <h3>{notification.title}</h3>
      </StyledNotificationTitleContainer>
      <StyledNotificationContentContainer>
        <span>{notification.content}</span>
      </StyledNotificationContentContainer>
      <StyledNotificationButtonContainer>
        <SubmitButton onClick={() => navigate(`/challenges/${notification.data.challengeId}`)} text='View Challenge' />
        <SubmitButton variant='danger' onClick={deleteNotification} text='Delete' />
      </StyledNotificationButtonContainer>
    </StyledNotificationContainer>
  );
}

export default ChallengeNotificationContent;